import areaController from "../../../controllers/areaController/controller";
import Swal from 'sweetalert2';
import { EventBus } from '@/eventBus';

export default {
    name: 'SimpleTable',
    data() {
        return {
            company: '',
            areaList: [],
            currentPage: 1,
            pageSize: 10,
            totalPages: 0,
            totalAreas: 0,
            searchQuery: '',
            area:{
                name_area: '',
                titik_area:'',
                language: '',
                created_by: '',
                created_by_name: '',
                created_on: '',
                status: ''
            },
            selectedArea: {
                updated_by: '',
                updated_by_name: '',    
                updated_on: '',
                status: ''
            }
        }
    },
    computed: {
        filteredAreas(){
            return this.areaList.filter(area => area.name_area.toLowerCase().includes(this.searchQuery.toLowerCase()));
        },
        pages(){
            return Math.ceil(this.totalAreas / this.pageSize);
        },
        displayedPages() {
            const range = 1;
            let start = Math.max(this.currentPage - range, 1);
            let end = Math.min(this.currentPage + range, this.pages);
      
            // Jika kurang dari 3 halaman, sesuaikan
            if (end - start < 2) {
              if (start === 1) {
                end = Math.min(3, this.pages);
              } else if (end === this.pages) {
                start = Math.max(this.pages - 2, 1);
              }
            }
      
            const pages = [];
            for (let i = start; i <= end; i++) {
              pages.push(i);
            }
            return pages;
        },
        showStartEllipsis() {
            return this.displayedPages[0] > 1;
        },
        showEndEllipsis() {
            return this.displayedPages[this.displayedPages.length - 1] < this.pages;
        },
    },
    methods:{
        user(){
            const user = localStorage.getItem('user');
            const id = JSON.parse(user).mst_employee_id;
            this.area.created_by = id;
            this.selectedArea.updated_by = id;
            const name = JSON.parse(user).mst_employee_name;
            this.area.created_by_name = name;
            this.selectedArea.updated_by_name = name;
        },
        showModal(type, id) {
            this.user();
            const area = this.areaList.find(area => area.id === id);
            if (area) {
                this.area = area;
                
                const modal = document.getElementById(type === 'edit' ? 'editArea' : 'detailArea');
                
                modal.style.display = 'block';
                requestAnimationFrame(() => {
                modal.classList.add('show');
                });
                
                document.body.classList.add('modal-open');
                
                const backdrop = document.createElement('div');
                backdrop.classList.add('modal-backdrop', 'fade');
                document.body.appendChild(backdrop);
                
                requestAnimationFrame(() => {
                backdrop.classList.add('show');
                });
            }
        },
        closeModal() {
          const modalIds = ['tambahArea', 'editArea', 'detailArea'];
          modalIds.forEach(id => {
            const modal = document.getElementById(id);
            if (modal && modal.classList.contains('show')) {
              modal.classList.remove('show');
              setTimeout(() => {
                modal.style.display = 'none';
              }, 300);
            }
          });
        
          // Hapus backdrop
          const backdrops = document.querySelectorAll('.modal-backdrop');
          backdrops.forEach(backdrop => {
            backdrop.classList.remove('show');
            setTimeout(() => {
              if (backdrop.parentNode) {
                backdrop.parentNode.removeChild(backdrop);
              }
            }, 300);
          });
        
          // Hapus kelas atau atribut yang mengunci scroll pada body
          const body = document.body;
          body.classList.remove('modal-open');
          body.style.overflow = ''; // Menghapus properti overflow jika ada
          this.fetchAreas();
          this.resetForm();
          this.user();
        },    
        resetForm() {
            this.area.name_area = '';
            this.area.titik_area = '';
            this.area.status = '';
            this.area.language = '';
        },
        changePage(page) {
            if (page > 0 && page <= this.pages) {
                this.currentPage = page;
                this.fetchAreas();
            }
        },
        async fetchAreas() {
            try {
                const company = this.company;
                console.log(company);
                //TERANG
                if (company !== '1') {
                    this.$router.replace({ path: '/' });
                    console.log('DISINI');
                    return;
                }
                const query = this.searchQuery.trim() === '' ? null : this.searchQuery;
    
                const response = await areaController.fetchAreas(query, this.currentPage, this.pageSize, company);
                this.areaList = response.data;
                this.totalAllAreas();
            } catch (error) {
                console.error('Error fetching areas:', error);
                throw error;
            }
        },
        async totalAllAreas() {
            try {
                const company = this.company;
                const query = this.searchQuery.trim() === '' ? null : this.searchQuery;
                const response = await areaController.totalAllAreas(query, company);
                this.totalAreas = response.data;
            } catch (error) {
                console.error('Error fetching areas:', error);
                throw error;
            }
        },
        async addArea() {
            try {
                const name = this.area.name_area;
                const area_point = this.area.titik_area;
                const created_by = this.area.created_by;
                const is_active = this.area.status;
                const created_by_name = this.area.created_by_name;
                const company = this.company;
                const language = this.area.language;
                if (!name || !area_point || !created_by || !is_active || !created_by_name || !language) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal menambahkan data',
                        text: 'Isi semua field!!',
                        timer: 1500
                    })
                    return;
                }
                const now = new Date();
                const date = now.toISOString().slice(0, 19).replace('T', ' ');
                const add = {
                    name : name,
                    area_point : area_point,
                    is_active : is_active,
                    created_by : created_by,
                    created_by_name : created_by_name,
                    id_company: company,
                    language : language,
                    created_on :date
                }
                const isEmpty = Object.values(add).some(val => val === null || val === '');
                if (isEmpty) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal menambahkan data',
                        text: 'Isi semua field!!',
                        timer: 1500
                    })
                }
                const response = await areaController.addArea(add);
                if (response.status === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Area berhasil ditambahkan',
                        timer: 1500
                    })
                    this.closeModal();
                    this.fetchAreas();
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal menambahkan data',
                        timer: 1500
                    })
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Gagal menambahkan data',
                    text: error.message,
                    timer: 1500
                })
            }
        },
        async updateArea() {
            try {
                const id = this.area.id;
                const name = this.area.name_area;
                const area_point = this.area.titik_area;
                const is_active = this.area.status;
                const updated_by = this.selectedArea.updated_by;
                const updated_by_name = this.selectedArea.updated_by_name;
                const language = this.area.language;
                const now = new Date();
                const date = now.toISOString().slice(0, 19).replace('T', ' ');
                if (!id || !name || !area_point || !is_active || !updated_by || !updated_by_name || !language) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal menambahkan data',
                        text: 'Isi semua field!!',
                        timer: 1500
                    })
                    return;
                }
                const update = {
                    id: id,
                    name: name,
                    area_point: area_point,
                    is_active: is_active,
                    updated_by: updated_by,
                    updated_by_name: updated_by_name,
                    language: language,
                    updated_on: date
                }
                const response = await areaController.updateArea(update);
                if (response.status === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Area berhasil diubah',
                        timer: 1500
                    })
                    this.closeModal();
                    this.fetchAreas();
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal mengubah data',
                        timer: 1500
                    })
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Gagal mengubah data',
                    text: error.message,
                    timer: 1500
                })
            }
        },
        async deleteArea(areaId) {
            const confirmed = await Swal.fire({
                title: 'Are you sure?',
                text: 'You won\'t be able to revert this!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    return true;
                }
                return false;
            });
            if (confirmed) {
                try {
                    await areaController.deleteArea(areaId);
                    Swal.fire({
                        icon : 'success',
                        title : 'Area berhasil dihapus',
                        timer : 1500
                    })
                    this.fetchAreas();
                } catch (error) {
                    alert('Gagal menghapus data: ' + error.message);
                }
            }
        },
        onCompanyChange(newCompany) {
            this.company = newCompany;
        }
    },
    mounted(){
        this.user();
        this.company = localStorage.getItem('company');
        EventBus.$on("companyChanged", this.onCompanyChange);
    },
    watch: {
        searchQuery: {
            handler: 'fetchAreas',
        },
        company: {
            handler: 'fetchAreas'
        }
    },
    beforeDestroy() {
        // bersihkan listener
        EventBus.$off("companyChanged", this.onCompanyChange);
    },
}
